import { IMainContext } from "./types";

export const initContext: IMainContext = {
  step: 1,
  setStep: () => {},
};
